/**
 * Player-name display helpers.
 *
 * Player display names are now sourced from the backend-canonical
 * `Player.name` field (SE-5469). The former client-side assembly helpers
 * (`getPlayerDisplayName`, `knownNameIsFullName`) were removed because the
 * backend already returns the fully-assembled name — including particles such
 * as "van"/"de" — so re-combining `firstName`/`knownName`/`lastName` on the
 * client only risked dropping or duplicating parts.
 */

/**
 * Fallback display name used when a player entity is absent (e.g. an activity
 * whose target player could not be resolved). `Player.name` itself is always
 * populated by the backend, so this is only a null-player guard.
 */
export const UNKNOWN_PLAYER = "Unknown Player";
